export default __webpack_public_path__ + "static/062-6a5c04db4749beaa31bee93f54ceaeb4.jpg";